import { gql } from '@apollo/client';

export const UPDATE_USER_FLOW_ACCESS_MODE_MUTATION = gql`
  mutation updateUserFlowAccessMode($groupId: Int!, $mode: EUserFlowAccessMode!) {
    userFlowAccessMode {
      updateUserFlowAccessMode: set(groupId: $groupId, mode: $mode)
    }
  }
`;
